import React from "react";
import { Button, Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { Color } from "../../../../Utils/styles";
import PlusIcon from "@mui/icons-material/AddCircle";
import Loading from "../../../Common/Loading";
import { Accordion as MuiAcc, AccordionDetails, AccordionSummary } from "@mui/material";
import { BsChevronDown } from "react-icons/bs";

function Question({ isApp, data = [], search, loading }) {
  if (loading) {
    return (
      <div className="container accordion-section">
        <div className="row">
          <div className="col-12">
            {" "}
            <Loading count={4} height={59} />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="container accordion-section">
      <div className="row">
        <div className="col-12">
          {data &&
            data.map((item, count) => {
              if (search.value) {
                if (
                  item.question.includes(search.value) ||
                  item.answer.includes(search.value)
                ) {
                  return <QuestionAccordion isApp={isApp} count={count} item={item} />;
                }
              } else if (search.category_id) {
                if (item.category_id == search.category_id) {
                  return <QuestionAccordion isApp={isApp} count={count} item={item} />;
                }
              } else {
                return <QuestionAccordion isApp={isApp} count={count} item={item} />;
              }
            })}
        </div>
      </div>
    </div>
  );
}
const QuestionAccordion = ({ count, item: { question, answer }, isApp }) => {
  if (isApp) {
    return (
      <div className="w-100 mb-2">
      <MuiAcc>
        <AccordionSummary
          expandIcon={<BsChevronDown color="#4F9CEC" size={"20px"} />}
          aria-controls="panel1a-content"
          id="panel1a-header" >
          <span className="nfs-12 fw500">
            {question}
          </span>
          <span className="fw300 nfs-12"
            style={{ marginRight: "auto", marginLeft: "5px", color: "#4F9CEC" }}>
            مشاهده
          </span>
        </AccordionSummary>
        <AccordionDetails>
          {answer}
        </AccordionDetails>
      </MuiAcc>
      </div>
    )
  }
  return (
    <Accordion className="accordion-box new-box-shadow">
      <Card key={count}>
        <Card.Header className="card-header-accordion">
          <Accordion.Toggle
            className="toggler-acc"
            as={Button}
            variant="link"
            eventKey={count + 1}
          >
            <p>{`${count + 1} - ${question}`}</p>

            <PlusIcon color={Color.primary} className="question-icon" />
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey={count + 1}>
          <Card.Body className="acc-body">
            <p>{answer}</p>
          </Card.Body>
        </Accordion.Collapse>
      </Card>{" "}
    </Accordion>
  );
};
export default Question;
